import $ from 'jquery';
import '../../js/third-party/live-agent';
import {delay} from 'underscore';
import {getLogger} from 'loglevel';
import {userService} from '../../services/CartUserService';
import config from '../../js/config';
import mediator from '../../js/mediator';

const log = getLogger('LiveAgent');

function setContactPreChatFields() {
  let userInfo = userService.userInfo;
  if (!userInfo || userService.isCartUserAGuest()) return;
  log.debug('LiveAgent setting contact fields', userService.userInfo);
  //wrapping prechat parameters in .push method, so they load when ready
  _la.push(
    // 6. set prechat data such as email, first name, last name, phone, company.
    // For Verical the data is from get user info.
    function() {
      _la.setPrechatFields({
        ContactFirstName: userInfo.firstName,
        ContactLastName: userInfo.lastName,
        ContactName: userInfo.fullName,
        ContactEmail: userInfo.email,
        ContactCompany: userInfo.company,
        ContactPhone: userInfo.phone
      });
    }
  );
}

function initializeLiveAgent() {
  const urlSearchParams = new URLSearchParams(window.location.search);
  const debugParam = urlSearchParams.get('debug_liveagent');
  const debug = debugParam === 'true';
  // Connect to live agent using a json configuration
  // This global method is defined in the live-agent.js
  window.initLiveAgent({
    // This is used on verical and cart so keeping it the same here
    debug: debug,
    orgId: config.salesforce.liveAgentOrgId,
    deploymentId: config.salesforce.liveAgentDeploymentId,
    chatButtonIds: config.salesforce.liveAgentChatButtonIds,
    srcUrl: config.salesforce.liveAgentSrcUrl,
    initUrl: config.salesforce.liveAgentInitUrl,
    showEngineer: true,
    subjectIndex: 0
  });
  mediator.on(config.events.cart.userInfoSet, setContactPreChatFields);
  setContactPreChatFields();
}

function setupListeners($parent) {
  if (!$parent.find('[data-chat-status]').length) {
    return;
  }
  document.querySelector('.Footer-chat-button-wrapper a').removeAttribute('href');
  var customerSupportElement = document.querySelector('.ContactUs-buttons a');
  if (customerSupportElement) {
    customerSupportElement.removeAttribute('href');
  }
  window._la = window._la || [];
  // listen to to the chat button click event then a live agent function to start a chat
  jQuery('.Chat-button').click((e) => {
    try {
      // window.open('', 'newwindow', 'width=480,height=500,scrollbars=yes');
      if (!_la.initWasCalled) {
        initializeLiveAgent();
      }
      setContactPreChatFields();
      let subjectIndex = 0;
      if ($(e.target).closest('.EngineerList-chat').length || $(e.target).closest('.SearchNoResults-buttons').length) {
        subjectIndex = 5;
      }
      let chatButton = $(e.target);
      let engineerChatOption = chatButton.data('engineer-chat-default-option');
      if (engineerChatOption) {
        subjectIndex = engineerChatOption;
      }
      // prefill chat form
      _la.push(function() {
        _la.setConfigField('subjectIndex', subjectIndex);
        _la.chatButtons[0].startChat();
      });
    } catch (err) {
      log.debug('LiveAgent issue starting chat', err);
    }
    e.preventDefault();
  });
}

export function createLiveAgent($parent) {
  delay(setupListeners, 1000, $parent);
}



// WEBPACK FOOTER //
// ./assets/components/LiveAgent/LiveAgent.js